import * as Yup from 'yup';

const OrderValidationSchema = Yup.object().shape({
  phone: Yup.string()
    .required('A phone number is required.')
    .length(10, 'Phone number must be 10 digits')
});

export default OrderValidationSchema;
